import { jwtTokenAtom, switchAtom, userInfoAtom } from '@/store/root'
import { UserOutlined } from '@ant-design/icons'
import arrow_d from '@i/global/arrow_d.svg'
import logo from '@i/global/logo.png'
import mp from '@i/global/mp.svg'
import u143 from '@i/global/u143.png'
import { getContactGetContentSwitch } from '@s/contact'
import { getSysGetInfo } from '@s/login'
import { Popover } from 'antd'
import Login from './login'
import Logout from './logout'

const Header = () => {
  const { pathname } = useLocation()

  const jwtToken = useAtomValue(jwtTokenAtom)
  const setUserInfo = useSetAtom(userInfoAtom)
  const setSwitchAtom = useSetAtom(switchAtom)

  const { data: userInfo } = useQuery({
    queryKey: ['用户信息', jwtToken],
    queryFn: () => getSysGetInfo(),
    select: res => {
      if (isValidRes(res)) return res.data
    },
    enabled: !!jwtToken,
  })

  const { data: switchData } = useQuery({
    queryKey: ['功能开关'],
    queryFn: () => getContactGetContentSwitch(),
    select: res => {
      if (isValidRes(res)) return res.data
    },
  })

  useEffect(() => {
    setUserInfo(userInfo)
  }, [userInfo])

  useEffect(() => {
    setSwitchAtom(switchData || {})
  }, [switchData])

  const isActive = (nav: string) => {
    let active = pathname.includes(nav)
    if (nav === 'home') {
      active = pathname === '/'
    }
    return active ? 'text-main font-bold border-main' : 'text-#333 border-#fff'
  }

  return (
    <div className="h-110px border-t border-t-4 bg-#faffff shadow border-main">
      <div className="h-full fcc">
        <div className="w-1200px flex">
          <div className="w-80 text-333 text-7 font-bold">
            <img alt="天福契约" height={37} src={logo} width={99} /> 天福契约
          </div>
          <div className="fcs flex-1">
            <Link
              className={clsx('mx-3 border-b-3px text-18px hover:text-main hover:font-bold', isActive('home'))}
              to="/"
            >
              首页
            </Link>
            <Link
              className={clsx('mx-3 border-b-3px text-18px hover:text-main hover:font-bold', isActive('products'))}
              to="/products"
            >
              服务产品
            </Link>
            <Link
              className={clsx('mx-3 border-b-3px text-18px hover:text-main hover:font-bold', isActive('about'))}
              to="/about"
            >
              关于我们
            </Link>
          </div>
          <div className="w-100 fcb">
            {!jwtToken && <Login />}
            <Popover arrow className={clsx({ hidden: !jwtToken })} content={<Logout />} placement="bottom">
              <div className="bg-main19 fc rounded-23px p-4px px-6px">
                <UserOutlined className="mx-1" />
                <span className="max-w-80px truncate text-main">{userInfo?.nickName || '用户昵称'}</span>
                <img className="w-15px" src={arrow_d} />
              </div>
            </Popover>
            <Link className="separator" to="/profile">
              个人主页
            </Link>
            <Link className="separator" to="/help">
              帮助中心
            </Link>
            <Popover arrow content={<img className="w-135px" src={u143} />} placement="bottom">
              <Link className="separator group" to="#">
                <img className="w-22px group-hover:text-main" src={mp} /> 微信小程序
              </Link>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
